/**
 * There will be one reducer file per page / common component
 */
import {
    SET_FILTERS,
    SET_SELECTED_DATE,
    SET_VISIBLE_DATE_RANGE,
    CALENDAR_VIEW,
    SET_SURGERY_DATES,
    SET_VIEWFILTER,
    OPEN_FILTERS,
    SET_SELECTED_CALENDAR_VIEW,
    SET_ACTION_ITEMS_ONLY,
    SET_EXPANDED_FILTER_VIEWS,
    SET_LIST_VIEW_START_DATE,
    SET_LIST_VIEW_END_DATE,
    SET_LIST_VIEW_PAGE_NUM,
    SET_SEARCH_PARAM,
    SET_SHOW_FILTER_RESULTS_PANEL,
    RESET_SELECTED_DATE,
    RESET_FILTER_DATA_AFTER_IMPERSONATION,
} from '../actions';
import {
    convertDateToISOString,
    dynamicLandingPageCalendarView,
    dynamicLandingPageVisibleDateRange,
} from 'src/utils/util';
import {
    normalizeToLocalCalendarDate,
    getEndOfTimeDate,
    getListOfLastThreeBusinessDays,
    getListOfDatesForLeadTimeLogic,
} from 'src/utils/dateUtils';
import { SET_HOLIDAY_LIST_AND_CALCULATE_LAST_THREE_BUSINESS_DAYS } from 'src/pages/scheduleSurgery/redux/actions';
import { SET_HOLIDAY_LIST_AND_UPCOMING_BUSINESS_DAYS_FOR_REQUEST_DELIVERY_DATE } from 'src/pages/scheduleSurgery/redux/actions';
import moment from 'moment';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // defaults to localStorage for web
import { SET_HOLIDAY_LIST_AND_UPCOMING_7_BUSINESS_DAYS_FOR_CONSIGNMENT_ADD } from 'src/pages/consignmentAdd/redux/actions';

const initialState = {
    userFilters: {
        startDate: convertDateToISOString(new Date(new Date()), 'start'),
        endDate: convertDateToISOString(getEndOfTimeDate(), 'end'),
        filterParam: '',
        resourceType: 'VIEW_DATA',
        filterByPhysician: [],
        filterByOrderStatus: [],
        orderType: [],
        filterByAccounts: [],
        filterByProcedure: [],
        sortOrder: 'ASC',
        sortParam: 'surgeryStartDate',
        // pageLimit: '',
        pageNum: 0,
    },
    isFilterPopoverOpen: false,
    viewFilter: 'All',
    selectedDate: new Date(new Date().setHours(0, 0, 0, 0)),
    // lastThreeBusinessDays:
    // getListOfLastThreeBusinessDays(
    //     new Date(new Date().setHours(0, 0, 0, 0)),
    //     []
    // ),
    lastThreeBusinessDays: [],
    upcomingBusinessDays: [],
    visibleDateRange: dynamicLandingPageVisibleDateRange(),
    calendarView: dynamicLandingPageCalendarView(),
    selectedCalendarView: {},
    actionItemsOnly: false,
    expandedFilterViews: {
        CalendarView: true,
        AccountView: false,
        OrderTypeView: true,
        OrderStatusView: true,
        PhysiciansView: false,
        ProcedureView: false,
        OrderCondition: false,
    },
    listViewStartDate: '',
    listViewEndDate: normalizeToLocalCalendarDate(new Date()),
    searchParam: '',
    pageNum: 0,
    showFilterResultsPanel: false,
    holidayDates: [],
};

const makeListOfHolidays = (holidayObjectList) => {
    return holidayObjectList
        ?.filter((item) => item.isHoliday === true)
        ?.map((item) => {
            return new Date(item.date.replace('Z', '')).valueOf();
        });
};

const FiltersReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_FILTERS: {
            let payload = action.payload;
            return {
                ...state,
                userFilters: {
                    ...state.userFilters,
                    ...payload,
                },
            };
        }
        case SET_SELECTED_DATE:
            return {
                ...state,
                selectedDate: action.payload,
            };
        case SET_VISIBLE_DATE_RANGE:
            return {
                ...state,
                visibleDateRange: action.payload,
            };
        case SET_VIEWFILTER:
            return {
                ...state,
                viewFilter: action.payload,
            };
        case CALENDAR_VIEW:
            return {
                ...state,
                calendarView: action.payload,
            };
        case SET_SURGERY_DATES:
            return {
                ...state,
                surgeryDates: action.payload,
            };
        case OPEN_FILTERS:
            return {
                ...state,
                isFilterPopoverOpen: action.payload,
            };
        case SET_SELECTED_CALENDAR_VIEW:
            return {
                ...state,
                selectedCalendarView: action.payload,
            };
        case SET_ACTION_ITEMS_ONLY:
            return {
                ...state,
                actionItemsOnly: action.payload,
            };
        case SET_EXPANDED_FILTER_VIEWS:
            return {
                ...state,
                expandedFilterViews: action.payload,
            };
        case SET_LIST_VIEW_START_DATE:
            return {
                ...state,
                listViewStartDate: normalizeToLocalCalendarDate(action.payload),
            };
        case SET_LIST_VIEW_END_DATE:
            return {
                ...state,
                listViewEndDate: normalizeToLocalCalendarDate(action.payload),
            };
        case SET_LIST_VIEW_PAGE_NUM:
            return {
                ...state,
                pageNum: action.payload,
            };
        case SET_SEARCH_PARAM:
            return {
                ...state,
                searchParam: action.payload,
            };
        case SET_SHOW_FILTER_RESULTS_PANEL:
            return {
                ...state,
                showFilterResultsPanel: action.payload,
            };
        case SET_HOLIDAY_LIST_AND_CALCULATE_LAST_THREE_BUSINESS_DAYS: {
            let yesterday = moment(new Date())
                .startOf('day')
                .subtract(1, 'days')
                .toDate();

            let listOfHolidaysInMillisecondsToExclude = makeListOfHolidays(
                action.payload
            );

            return {
                ...state,
                holidayDates: listOfHolidaysInMillisecondsToExclude,
                lastThreeBusinessDays: getListOfLastThreeBusinessDays(
                    yesterday,
                    [],
                    listOfHolidaysInMillisecondsToExclude
                ),
            };
        }

        case SET_HOLIDAY_LIST_AND_UPCOMING_BUSINESS_DAYS_FOR_REQUEST_DELIVERY_DATE: {
            let tomorrowDate = moment(new Date())
                .startOf('day')
                .add(1, 'days')
                .toDate();
            let listOfHolidaysInMillisecondsToExclude = makeListOfHolidays(
                action.payload.result
            );

            return {
                ...state,
                holidayDates: listOfHolidaysInMillisecondsToExclude,
                upcomingBusinessDaysAndHolidays: getListOfDatesForLeadTimeLogic(
                    tomorrowDate,
                    listOfHolidaysInMillisecondsToExclude,
                    action.payload.leadTime,
                    'surgery'
                ),
            };
        }

        case SET_HOLIDAY_LIST_AND_UPCOMING_7_BUSINESS_DAYS_FOR_CONSIGNMENT_ADD: {
            let tomorrowDate = moment(new Date())
                .startOf('day')
                .add(1, 'days')
                .toDate();
            let listOfHolidaysInMillisecondsToExclude = makeListOfHolidays(
                action.payload.result
            );

            return {
                ...state,

                upcomingBusinessDaysAndHolidays: getListOfDatesForLeadTimeLogic(
                    tomorrowDate,
                    listOfHolidaysInMillisecondsToExclude,
                    2,
                    'kb'
                ),
            };
        }
        case RESET_SELECTED_DATE:
            return {
                ...state,
                listViewStartDate: initialState.listViewStartDate,
                listViewEndDate: initialState.listViewEndDate,
            };
        case RESET_FILTER_DATA_AFTER_IMPERSONATION:
            return {
                ...initialState,
            };
        default: {
            return {
                ...state,
            };
        }
    }
};

export default persistReducer(
    {
        key: 'appliedCalendarFilterKey',
        storage: storage,
        whitelist: ['listViewStartDate', 'listViewEndDate', 'holidayDates'],
    },
    FiltersReducer
);
